import React from 'react';
import DOMPurify from 'dompurify';
import { css } from '@emotion/css';
import { corporateGreyLight } from '../assets/colors';
import { Localized, useLocalizedString } from './Localized';

/**
 * @brief This render component display question, answer and score for a specific question
 * @param {String} question HTML string that displays the question text
 * @param {String} answer HTML string that displays the answer text that was submitted by the user
 * @param {Int} score the score that is associated with the answer of the participant
 */
const QuestionAnswerBox = (props) => {
    return (
        <div
            className={css({
                width: '100%',
                display: 'flex',
                alignItems: 'stretch',
                marginBottom: '1.2mm',
                pageBreakInside: 'avoid',
            })}
        >
            <div
                className={css({
                    width: '100%',
                })}
            >
                <QuestionElement title={<Localized de={'Frage'} en={'Question'} />}>{props.question}</QuestionElement>
                <QuestionElement title={<Localized de={'Antwort'} en={'Answer'} />}>{props.answer}</QuestionElement>
            </div>
            <div
                className={css({
                    padding: '2mm',
                    marginLeft: '1.5pt',
                    marginBottom: '1.5pt',
                    backgroundColor: corporateGreyLight,
                    textAlign: 'center',
                })}
            >
                <div
                    className={css({
                        position: 'relative',
                        top: '50%',
                        transform: 'translateY(-50%)',
                    })}
                >
                    <b>Score</b>
                    <br />
                    {props.score}
                </div>
            </div>
        </div>
    );
};
/**
 * @brief This render component display a single question or answer
 * @param {String} title describes what type this item is of
 * @param {String} children HTML string that displays the question or answer text
 */
const QuestionElement = (props) => {
    const text = useLocalizedString(props.children);
    return (
        <div
            className={css({
                display: 'flex',
                padding: '2mm',
                backgroundColor: corporateGreyLight,
                marginBottom: '1.5pt',
            })}
        >
            <div
                className={css({
                    fontWeight: 'bold',
                    width: '16mm',
                    flexShrink: 0,
                })}
            >
                {props.title}
            </div>
            <div
                className={css({
                    flexGrow: 1,
                    paddingLeft: '2mm',
                    lineHeight: '105%',
                })}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
            />
        </div>
    );
};

export default QuestionAnswerBox;
